import { PreloadAllModules, provideRouter, Routes, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withPreloading } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'terms-of-use',
		pathMatch: 'full'
	},
	{
		path: ':tab',
		loadChildren: () => import('./pages/policies/policies.route').then((page) => page.routes)
	},
	{
		path: '**',
		redirectTo: 'terms-of-use'
	}
];

export const appRouteProviders = [
	provideRouter(
		routes,
		withInMemoryScrolling({
			scrollPositionRestoration: 'top'
		}),
		withPreloading(PreloadAllModules)
	)
];
